import {
  ACTIVITY_LOG_KEY,
  BILLING_STATUS_KEY,
  CURRENT_CHANGE_KEY,
  CURRENT_EXPERIMENT_KEY,
  CURRENT_REPORT_KEY,
  CURRENT_SESSION_REPORT_KEY,
  CURRENT_VARIANT_KEY,
  LATEST_REPORT_SNAPSHOT_KEY,
  LIST_CHANGES_KEY,
  LIST_EXPERIMENTS_KEY,
  LIST_VARIANTS_KEY,
  SHOPIFY_SYNC_STATUS_KEY,
} from "./constants"

export const queryKeys = {
  experiments: {
    all: [LIST_EXPERIMENTS_KEY] as const,
    list: (workspaceId: string | undefined, status: string | undefined, limit: number) =>
      [LIST_EXPERIMENTS_KEY, workspaceId, status, limit] as const,
    detail: (experimentId: string | undefined) =>
      [CURRENT_EXPERIMENT_KEY, experimentId] as const,
    report: (
      experimentId: string | undefined,
      objectiveId: number | undefined,
      from: string | undefined,
      to: string | undefined,
    ) => [CURRENT_REPORT_KEY, experimentId, objectiveId, from, to] as const,
    reports: (experimentId: string | undefined) =>
      [CURRENT_REPORT_KEY, experimentId] as const,
    sessionReport: (
      experimentId: string | undefined,
      from: string | undefined,
      to: string | undefined,
    ) => [CURRENT_SESSION_REPORT_KEY, experimentId, from, to] as const,
    sessionReports: (experimentId: string | undefined) =>
      [CURRENT_SESSION_REPORT_KEY, experimentId] as const,
    snapshotMetadata: (experimentId: string | undefined) =>
      [LATEST_REPORT_SNAPSHOT_KEY, experimentId] as const,
  },
  variants: {
    all: [LIST_VARIANTS_KEY] as const,
    list: (experimentId: string | null | undefined) =>
      [LIST_VARIANTS_KEY, experimentId] as const,
    detail: (variantId: string | undefined) =>
      [CURRENT_VARIANT_KEY, variantId] as const,
  },
  changes: {
    all: [LIST_CHANGES_KEY] as const,
    list: (variantId: string | undefined) => [LIST_CHANGES_KEY, variantId] as const,
    detail: (changeId: string | undefined) => [CURRENT_CHANGE_KEY, changeId] as const,
  },
  activity: {
    all: [ACTIVITY_LOG_KEY] as const,
    list: (workspaceId: string | undefined) => [ACTIVITY_LOG_KEY, workspaceId] as const,
  },
  billing: {
    all: [BILLING_STATUS_KEY] as const,
    status: (workspaceId: string | undefined) => [BILLING_STATUS_KEY, workspaceId] as const,
  },
  shopifySync: {
    all: [SHOPIFY_SYNC_STATUS_KEY] as const,
    status: (workspaceId: string | undefined) => [SHOPIFY_SYNC_STATUS_KEY, workspaceId] as const,
  },
} as const
